import { FaYoutube, FaInstagram, FaFacebookF, FaTiktok, FaLinkedinIn, FaXTwitter, FaWhatsapp, FaVimeoV, FaSpotify, FaSnapchat, FaThreads, FaTelegram, FaPinterestP, FaTwitch } from "react-icons/fa6";
import { Globe } from "lucide-react";

// platform key -> { label, color (brand), Icon }
export const SOCIAL_PLATFORMS = {
  youtube: { label: "YouTube", color: "#FF0000", Icon: FaYoutube },
  instagram: { label: "Instagram", color: "#E4405F", Icon: FaInstagram },
  facebook: { label: "Facebook", color: "#1877F2", Icon: FaFacebookF },
  tiktok: { label: "TikTok", color: "#FFFFFF", Icon: FaTiktok },
  linkedin: { label: "LinkedIn", color: "#0A66C2", Icon: FaLinkedinIn },
  x: { label: "X (Twitter)", color: "#FFFFFF", Icon: FaXTwitter },
  whatsapp: { label: "WhatsApp", color: "#25D366", Icon: FaWhatsapp },
  vimeo: { label: "Vimeo", color: "#1AB7EA", Icon: FaVimeoV },
  spotify: { label: "Spotify", color: "#1DB954", Icon: FaSpotify },
  snapchat: { label: "Snapchat", color: "#FFFC00", Icon: FaSnapchat },
  threads: { label: "Threads", color: "#FFFFFF", Icon: FaThreads },
  telegram: { label: "Telegram", color: "#26A5E4", Icon: FaTelegram },
  pinterest: { label: "Pinterest", color: "#BD081C", Icon: FaPinterestP },
  twitch: { label: "Twitch", color: "#9146FF", Icon: FaTwitch },
  website: { label: "Site web", color: "#3E9BFF", Icon: Globe },
};

export const SOCIAL_OPTIONS = Object.entries(SOCIAL_PLATFORMS).map(([value, v]) => ({ value, label: v.label }));

export const SocialIcons = ({ socials = [], size = 18, className = "" }) => {
  const list = (socials || []).filter((s) => s && s.url && s.platform);
  if (!list.length) return null;
  return (
    <div className={`flex items-center gap-3 flex-wrap ${className}`} data-testid="social-icons">
      {list.map((s, i) => {
        const p = SOCIAL_PLATFORMS[s.platform] || SOCIAL_PLATFORMS.website;
        const Icon = p.Icon;
        return (
          <a key={s.id || i} href={s.url} target="_blank" rel="noreferrer" title={p.label}
            data-testid={`social-${s.platform}`}
            className="group relative w-11 h-11 rounded-full border border-white/15 flex items-center justify-center transition-[border-color,transform] duration-300 hover:-translate-y-0.5"
            style={{ ["--brand"]: p.color }}
            onMouseEnter={(e) => { e.currentTarget.style.borderColor = p.color; }}
            onMouseLeave={(e) => { e.currentTarget.style.borderColor = "rgba(255,255,255,0.15)"; }}>
            <Icon size={size} color={p.color} />
          </a>
        );
      })}
    </div>
  );
};
